import React, { useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
// import bgImage from "../images/Individual leaderboard.png";
function BKBLeaderboard() {
	const [cookies] = useCookies(['user']);
	const user_id = cookies.user_id;
	const token = cookies.token;
	const items = [];
	const items2 = [];
	// const prevScrollY = useRef(0);
	let history = useHistory();
	useEffect(() => {
		localStorage.setItem("loader", "free");
		getLeaderboardData();
	}, []);
	const [leaderData, setLeaderData] = useState({"status":"failuer","self":{"dist_user_id": "","rank": "NA","points": 0,"name": "","city": "","profile_pic": ""},"leaders":[]});
	const [error1, setError] = useState(false);
	const [seasonAward, setSeasonAward] = useState('');
	const [leaders, setLeaders] = useState([]);
	const [finalLeaders, setFinalLeaders] = useState([]);
	const [startRank, setStartRank] = useState(1);
	const [endRank, setEndRank] = useState(10);

	const prevScrollY = useRef(0);
  	const [goingUp, setGoingUp] = useState(false);
	const onScroll = (e) => {
		console.log("here");
		const currentScrollY = e.target.scrollTop;
		if (prevScrollY.current < currentScrollY && goingUp) {
			setGoingUp(false);
		}
		if (prevScrollY.current > currentScrollY && !goingUp) {
			setGoingUp(true);
		}
		prevScrollY.current = currentScrollY;
		console.log(currentScrollY);
		console.log(e.target.scrollHeight);

		if (Math.ceil(window.innerHeight +currentScrollY) > e.target.scrollHeight) {
			// Do load more content here!
			console.log("bottom");
			loadMore("down")
		}
		if(currentScrollY === 0){
			console.log("top");
			loadMore("up")
		}
	};

	async function loadMore(params){
		if(localStorage.getItem("loader") === "free"){
			localStorage.setItem("loader", "loading");
		if(params === "down"){
			let s = endRank + 1;
			let e = endRank + 100;
			const requestOptions = {
				method: 'POST',
				headers: { 'Content-Type': 'application/json','token':token,'userId':user_id  },
				body: JSON.stringify({dist_user_id:user_id,start_rank:s,end_rank:e}),	
			};
			const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-leaderboard', requestOptions);
			const data = await response.json();
			if (data.status !== "success"){
				setError(true);
			}
			for (const [index, value] of data.leaders.entries()) {
				let pp = '';
				if(value.profile_pic === 'NA' || value.profile_pic === ''){
					pp = require("./../images/defaultProfile.png").default;
				} else {
					pp = value.profile_pic;
				}
				let row = await getHtml(value);
				items.push(row);
		 	}
			// setLeaders(leaders.concat(items));
			await addMilestoneCards(leaders.concat(items));
			// console.log(leaders);
			setEndRank(data.end_rank);
		}
		if(params === "up"){
			let s = startRank - 100;
			if(s <= 0){
				s= 1;
			}
			let e = startRank - 1;
			const requestOptions = {
				method: 'POST',
				headers: { 'Content-Type': 'application/json','token':token,'userId':user_id  },
				body: JSON.stringify({dist_user_id:user_id,start_rank:s,end_rank:e,order:"desc"}),	
			};
			const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-leaderboard', requestOptions);
			const data = await response.json();
			if (data.status !== "success"){
				setError(true);
			}
			//var new_items = [];
			for (const [index, value] of data.leaders.entries()) {
				let pp = '';
				if(value.profile_pic === 'NA' || value.profile_pic === ''){
					pp = require("./../images/defaultProfile.png").default;
				} else {
					pp = value.profile_pic;
				}
				let row = await getHtml(value);
				leaders.unshift(row);
		  	}
			await addMilestoneCards(leaders.concat(items));
			// setLeaders(items.concat(leaders));
			// console.log(leaders);
			setStartRank(data.start_rank);
		}
			localStorage.setItem("loader", "free");
		}
	}
	const getLeaderboardData = async () => {
		
		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json','token':token,'userId':user_id  },
			body: JSON.stringify({dist_user_id:user_id}),
			
		};
		localStorage.setItem("milestone", JSON.stringify({"l1":"","l5":"","l10":"","l25":""}));
		const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-leaderboard', requestOptions);
		const data = await response.json();
		if (data.status !== "success"){
			setError(true);
		}
		for (const [index, value] of data.leaders.entries()) {
			let pp = '';
			if(value.profile_pic === 'NA' || value.profile_pic === ''){
				pp = require("./../images/defaultProfile.png").default;
			} else {
				pp = value.profile_pic;
			}
			let row = await getHtml(value, data.self.dist_user_id);
			localStorage.setItem("selfPoints", data.self.points);
			localStorage.setItem("selfRank", data.self.rank);
			let currentPoints = value.points;
			items.push(row);
		}
		// console.log(items);
		// delete items[49];
		// setLeaders(items);
		await addMilestoneCards(items);
		setSeasonAward(data.season_data.banner);
		setLeaderData(data);
		setStartRank(data.start_rank);
		setEndRank(data.end_rank);
	};

	async function addMilestoneCards(lead){
		// setLeaders(lead);
		console.log(lead.length);
		let i = 0;
		let l1 = '';
		let l5 = '';
		let l10 = '';
		let l25 = '';
		let selfPoints = localStorage.getItem("selfPoints");
		selfPoints = selfPoints.replaceAll(',','');
		for(;i<lead.length;i++){
			let key = lead[i].key;
			if(key === "1l" || key === "5l" || key === "10l" || key === "25l"){
				delete leaders[i];
				continue;
			}
			if(selfPoints >= 2500000){
				l10 = 'done';
				l5 = 'done';
				l1 = 'done';
			} else if(selfPoints < 2500000 && selfPoints >= 1000000) {
				l5 = 'done';
				l1 = 'done';
			} else if(selfPoints < 1000000 && selfPoints >= 500000) {
				l1 = 'done';
			}

			key = key.split('-');
			// console.log(key[0]);
			console.log(key[1]);
			let points = key[1];
			points = points.replaceAll(',','');
			if(l25 === '' && points < 2500000){
				l25 = 'done';
				let img = require("./../images/10-gm-unachieved.png").default;
				if(selfPoints >= 2500000){
					img = require("./../images/10-gm-achieved.svg").default;
				}
				items2.push(
					<div key="25l" className="row row-mrg-override">
						<div className="w-100 mrg-10 top-rank">
							<img src={img} alt="back" className="img-fluid" />
						</div>
					</div>
				);
				// setLeaders(items.concat(leaders));
			}
			if(l10 === '' && points < 1000000){
				l10 = 'done';
				let img = require("./../images/5-gm-unachieved.svg").default;
				if(selfPoints >= 1000000){
					img = require("./../images/5-gm-achieved.svg").default;
				}
				items2.push(
					<div key="10l" className="row row-mrg-override">
						<div className="w-100 mrg-10 top-rank">
							<img src={img} alt="back" className="img-fluid" />
						</div>
					</div>
				);
				// setLeaders(items.concat(leaders));
			}
			if(l5 === '' && points < 500000){
				l5 = 'done';
				let img = require("./../images/10k-unachieved.svg").default;
				if(selfPoints > 500000){
					img = require("./../images/10k-achieved.svg").default;
				}
				items2.push(
					<div key="5l" className="row row-mrg-override">
						<div className="w-100 mrg-10 top-rank">
							<img src={img} alt="back" className="img-fluid" />
						</div>
					</div>
				);
				// setLeaders(items.concat(leaders));
			}
			if(l1 === '' && points < 100000){
				l1 = 'done';
				let img = require("./../images/3k-unachieved.svg").default;
				if(selfPoints > 100000){
					img = require("./../images/3k-achieved.svg").default;
				}
				items2.push(
					<div key="1l" className="row row-mrg-override">
						<div className="w-100 mrg-10 top-rank">
							<img src={img} alt="back" className="img-fluid" />
						</div>
					</div>
				);
				// setLeaders(items.concat(leaders));
			}
			items2.push(lead[i]);
		}
		setLeaders(items2);
		
	}

	async function getHtml(value, distUserId='', selfPoints=''){
		let html = '';
		let a = JSON.parse(localStorage.getItem("milestone"));
		let num_font_sz = "";
		let selfRank = localStorage.getItem("selfRank");
		// localStorage.setItem("milestone",JSON.stringify((a)));
		console.log(value.city);
		console.log(value.name);
		if(value.rank === "1"){
			html = 
			<div key={value.dist_user_id+"-"+value.points} className="row row-mrg-override position-relative">
				<div className="w-100 top-rank" style={{margin : "2vh 0 2vh 0"}}>
					<img src={require("./../images/1st.svg").default} alt="back" className="img-fluid" />
				</div>
				<div className="w-100 pad-l-15 top-rank relative-data">
					<div className="w-50 margin-data col-bluver">
						<div className="top-title noWrap text-color " title={value.name}>{value.name}</div>
						<div className="top-shop noWrap text-color " title={value.city}>{value.city}</div>
						<div className="top-shop noWrap text-color " title={value.company_name}>{value.company_name}</div>
						<div className="top-points">
							<span><img src={require("./../images/pay1-points-img.svg").default} alt="point-icon" className="img-fluid"/></span>
							<span className="top-points-val text-color">{value.points}</span>
						</div>
					</div>
				</div>
			</div>;
		} else if(value.rank === "2"){
			html = 
			<div key={value.dist_user_id+"-"+value.points} className="row row-mrg-override position-relative">
				<div className="w-100 top-rank" style={{margin : "2vh 0 2vh 0"}}>
					<img src={require("./../images/2nd.svg").default} alt="back" className="img-fluid" />
				</div>
				<div className="w-100 pad-l-15 top-rank relative-data">
					<div className="w-50 margin-data col-bluver">
						<div className="top-title noWrap text-color" title={value.name}>{value.name}</div>
						<div className="top-shop noWrap text-color" title={value.city}>{value.city}</div>
						<div className="top-shop noWrap text-color" title={value.company_name}>{value.company_name}</div>
						<div className="top-points">
							<span><img src={require("./../images/pay1-points-img.svg").default} alt="point-icon" className="img-fluid"/></span>
							<span className="top-points-val text-color">{value.points}</span>
						</div>
					</div>
				</div>
			</div>;

		} else if(value.rank === "3"){
			html = 
			<div key={value.dist_user_id+"-"+value.points} className="row row-mrg-override position-relative">
				<div className="w-100 top-rank" style={{margin : "2vh 0 2vh 0"}}>
					<img src={require("./../images/3rd.svg").default} alt="back" className="img-fluid" />
				</div>
				<div className="w-100 pad-l-15 top-rank relative-data">
					<div className="w-50 margin-data col-wht">
						<div className="top-title noWrap" title={value.name}>{value.name}</div>
						<div className="top-shop noWrap">{value.city}</div>
						<div className="top-shop noWrap" title={value.company_name}>{value.company_name}</div>
						<div className="top-points">
							<span><img src={require("./../images/pay-point-icon.svg").default} alt="point-icon" className="img-fluid"/></span>
							<span className="top-points-val">{value.points}</span>
						</div>
					</div>
				</div>
			</div>;

		} else if(value.dist_user_id == distUserId ){
			num_font_sz = "num-font-sz-large";
			if (value.rank > '99') {
				num_font_sz = "num-font-sz-small";
			}
			let bgStyle = {
				backgroundImage : `url(${require("../images/Individual_leaderboard.png").default})`
			}
			html = 
			<div key={value.dist_user_id+"-"+value.points} className="row row-mrg-override margin-cont">
				<div className="w-15 position-relative vcenter">
					<div className="numWhtImgCont">
						<div className={`numImg ${num_font_sz} vcenter2`}>{value.rank}</div>
					</div>
				</div>
				<div className="w-80  col-bluver bg-wht flt-lft pad-tb5-lr10" style={bgStyle}>
					<div className="w-65 flt-lft top-data">
						<div className="top-title">{value.name}</div>
						<div className="top-shop">{value.city}</div>
						<div className="top-shop">{value.company_name}</div>
					</div>
					<div className="w-35 txt-rgt top-points top-points-2">
						<span className="top-points-val">{value.points}</span>
						<span className="top-points-img"><img style={{backgroundColor : "#fff", borderRadius : "50%"}} src={require("./../images/pay-point-icon.svg").default} alt="point-icon" className="img-fluid"/></span>
					</div>
				</div>
			</div>;
		} else {
			num_font_sz = "num-font-sz-large";
			if (value.rank > '99') {
				num_font_sz = "num-font-sz-small";
			}
			
			html = 
			<div key={value.dist_user_id+"-"+value.points} className="row row-mrg-override margin-cont">
				<div className="w-15 position-relative vcenter">
					<div className="numWhtImgCont">
						<div className={`numImg ${num_font_sz} vcenter2`}>{value.rank}</div>
					</div>
				</div>
				<div className="w-80 col-bluver bg-wht flt-lft pad-tb5-lr10">
					<div className="w-65 flt-lft top-data">
						<div className="top-title">{value.name}</div>
						<div className="top-shop">{value.city}</div>
						<div className="top-shop">{value.company_name}</div>
					</div>
					<div className="w-35 txt-rgt top-points top-points-2">
						<span className="top-points-val">{value.points}</span>
						<span className="top-points-img"><img style={{backgroundColor : "#fff", borderRadius : "50%"}} src={require("./../images/pay1-points-img.svg").default} alt="point-icon" className="img-fluid"/></span>
					</div>
				</div>
			</div>;
		}
		return html;
	}
	return (
<>
	{/* <HelmetProvider> */}
		<Helmet link={
			[{"rel": "stylesheet", "href": 'css/leaderboard.css'}]
		}/>
	{/* </HelmetProvider> */}
	<div className="row no-gutters">
		{ error1 === false && (
		<div className="application">
            
			<div className="leaderboard-section-2" id="bg-grey-2" onScroll={onScroll}>
				{leaders}
			</div>
    </div>
		)}
		{ error1 === true && (
			<Redirect to='/'  />
		)}
		<div className="bg"></div>
	</div>
</>
	);
}

export default BKBLeaderboard;
